module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-8-217d62d66ae16b60c336df5240b2c394.webp";